/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    bool, func, object, string,
} from 'prop-types';

import {
    Dialog, DialogContent, DialogTitle, Grid, IconButton, makeStyles,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { useDispatch } from 'react-redux';
import EnterpriseCalendarContainer from './EnterpriseCalendarContainer';

import { calendarColorStyle } from '../Helpers/Style-Helper';
import CloseCalendarConsent from './partials/CloseCalendarConsent/CloseCalendarConsent';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const useStyles = makeStyles(
    (theme) => ({
        rootDialog: {
            color: calendarColorStyle.primary?.main,
        },
        rootDialogPaper: {
            borderRadius: '8px',
            marginTop: 0,
            width: '474px',
            height: 'auto',
            minHeight: '472px',
            maxHeight: 'calc(100vh - 80px)',
            top: '40px',
            position: 'absolute',
            [theme.breakpoints.down(490)]: {
                borderRadius: '0',
                height: '100%',
                minHeight: '320px',
                maxHeight: '100%',
                top: 0,
                width: '100%',

            },
        },
        errorDialogContent: {
            minHeight: '120px',
        },
        woMODialogContent: {
            minHeight: '318px',
        },
        titleDialog: {
            borderBottom: `1px solid ${calendarColorStyle.primary?.[200]}`,
            padding: '8px 24px',
            [theme.breakpoints.down(490)]: {
                position: 'relative',
                padding: '8px 16px',
            },
        },
        dialogContent: {
            padding: 0,
        },
        dialogCloseIcon: {
            margin: 0,
            padding: 0,
        },
        closeIcon: {
            width: '22px',
            height: '22px',
        },

    }),
    { name: 'EnterpriseCalendarDialog' },
);

const EnterpriseCalendarDialog = ({
    handleDeliveryCalendarClose,
    recipientItem,
    openCalendar,
    orderItem,
    pageType,
}) => {
    const dispatchAction = useDispatch();
    const classes = useStyles();

    const [errorMessage, setErrorMessage] = useState('');
    const [isWOMOCalendar, setWOMOCalendar] = useState('');
    const [isCalendarSelectionChanged, setCalendarSelectionChanged] = useState(false);
    const [isOpenCalendarConsent, setOpenCalendarConsent] = useState(false);

    const handleCloseCalendarConsent = () => {
        if (isCalendarSelectionChanged) {
            setOpenCalendarConsent(true);
        } else {
            dispatchAction(
                trackEvent({
                    eventName: 'feature_interaction',
                    eventCategory: 'Checkout',
                    eventAction: 'Calendar',
                    eventLabel: 'Calendar X Click',
                }),
            );
            handleDeliveryCalendarClose();
        }
    };

    return (
        <Dialog
            id="modal-enterprise-calendar"
            open={openCalendar}
            fullScreen
            classes={{
                root: classes.rootDialog,
                paper: `${classes.rootDialogPaper} ${errorMessage ? classes.errorDialogContent : ''} ${isWOMOCalendar ? classes.woMODialogContent : ''}`,
            }}
        >
            <DialogTitle className={classes.titleDialog}>
                <Grid container justifyContent="flex-end">
                    <IconButton
                        id="close-enterprise-calendar-close-button"
                        color="inherit"
                        onClick={handleCloseCalendarConsent} // TODO: look if need confirmation for close. refer to food calendar
                        aria-label="Close"
                        data-test="enterprise-calendar-close-button"
                        className={classes.dialogCloseIcon}
                    >
                        <CloseIcon className={classes.closeIcon} />
                    </IconButton>
                </Grid>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <EnterpriseCalendarContainer
                    setCalendarSelectionChanged={setCalendarSelectionChanged}
                    handleDeliveryCalendarClose={handleDeliveryCalendarClose}
                    isOpenCalendarConsent={isOpenCalendarConsent}
                    orderItem={orderItem}
                    pageType={pageType}
                    recipientItem={recipientItem}
                    setErrorMessage={setErrorMessage}
                    setWOMOCalendar={setWOMOCalendar}
                />
            </DialogContent>
        </Dialog>
    );
};

EnterpriseCalendarDialog.propTypes = {
    handleDeliveryCalendarClose: func.isRequired,
    recipientItem: object.isRequired,
    openCalendar: bool.isRequired,
    orderItem: object.isRequired,
    pageType: string.isRequired,
};

export default EnterpriseCalendarDialog;
